module.exports = "<div #publisherDiv></div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/open-tok/publisher/publisher.component.html
// module id = ../../../../../src/app/shared/components/open-tok/publisher/publisher.component.html
// module chunks = main